import { IBookingTimeChangelogEntry, IBookingTimeChangelogEntryFromPouch } from "shared-types/index";
import { version } from "yargs";
import DateUtilsService from 'external-services/date-utils-service/index';

/**
 * 
 * @param bookingTimeChangelog 
 * @returns Latest booking time change entry or null otherwise. 
 */
export function getLatest(bookingTimeChangelog: IBookingTimeChangelogEntry[]) : IBookingTimeChangelogEntry {    
    if(!bookingTimeChangelog) {
        throw new Error("`bookingTimeChangelog` must not be null or undefined")
    }
    
    if(bookingTimeChangelog.length === 0){
        return null;
    }
    bookingTimeChangelog.sort((a,b) => b.version - a.version);
    return bookingTimeChangelog[0];
}

/**
 * Updates a bookingTimeChangeLog array with a new time, if the time has changed since the latest entry.
 * @param bookingTimeChangelog 
 * @param time 
 * @returns 
 */
export function update(bookingTimeChangelog: IBookingTimeChangelogEntry[], time: Date) {    
    const latest = getLatest(bookingTimeChangelog);

    if(latest === null){
        bookingTimeChangelog.push({version: 1, time: time});
        return;
    }

    //No changes to time, do nothing
    if(latest.time.getTime() === time.getTime()){
        return;
    }

    //Push to front to try and keep the latest item in position 0, matches BE behaviour.
    bookingTimeChangelog.unshift({version: latest.version + 1, time: time});
}

export function toPouchEntry(entry: IBookingTimeChangelogEntry) : IBookingTimeChangelogEntryFromPouch {
    return  {
        version: entry.version,
        time: DateUtilsService.dateToDateTimeStr(entry.time)
    }
}
